import './App.scss';
// import './forms.scss';
import { MuiThemeProvider } from '@material-ui/core';
import theme from './theme/theme';
import Switcher from './components/switcher';
const App = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <div className="App">
        <Switcher />
      </div>
    </MuiThemeProvider>
  );
};

export default App;
